export default __webpack_public_path__ + "static/media/internshipArticleImage2.743bc8b9.svg";